(ns common.schema.entities.workspace.kyc.questions.tenant
  (:require
   [common.email :as common-email]
   [common.country :as country]
   [common.schema.entities.workspace.kyc.kyc-options :as kyc-options]))

(def all-questions
  {:kyc-tenant/name
   {:data/type    :data.type/text-simple
    :translations {:en "Name of the tenant"
                   :fi "Vuokralaisen nimi"}}

   :kyc-tenant/business-id
   {:data/type    :data.type/text-simple
    :translations {:en "Business ID"
                   :fi "Y-tunnus"}}

   :kyc-tenant/mailing-address
   {:data/type    :data.type/text-multiline
    :translations {:en "Mailing address"
                   :fi "Postisoite"}}

   :kyc-tenant/registered-address
   {:data/type    :data.type/text-simple
    :translations {:en "Registered address"
                   :fi "Osoite"}}

   :kyc-tenant/zip-code
   {:data/type    :data.type/text-simple
    :translations {:en "Zip code"
                   :fi "Postinumero"}}

   :kyc-tenant/city
   {:data/type    :data.type/text-simple
    :translations {:en "City"
                   :fi "Kaupunki"}}

   :kyc-tenant/domicile
   {:data/type    :data.type/keyword
    :options      country/options
    :translations {:en "Domicile"
                   :fi "Kotipaikka"}}

   :kyc-tenant/industry
   {:data/type    :data.type/text-simple
    :translations {:en "Industry"
                   :fi "Toimiala"}}

   :kyc-tenant/listed-in-stock-exchange?
   {:data/type    :data.type/keyword
    :options      kyc-options/yes-no-options
    :translations {:en "Is the tenant listed on stock exchange stated in details"
                   :fi "Onko vuokralainen listattu pörssiin?"}}

   :kyc-tenant/ubo-edn
   {:data/type         :data.type/text-edn
    :edn-data/type     :edn-data.type/ubo-list
    :mandatory-field? (fn [_answers kyc-process]
                        (not= (:kyc-process/status kyc-process)
                              :kyc-process.status/draft))
    :conditional-field (fn [answers _kyc-process]
                         (= :no (:kyc-tenant/listed-in-stock-exchange? answers)))
    :data/template     nil ;; MUST BE OVERRIDDEN by schema to avoid circular references
    :translations      {:en "Ultimate beneficial owners (UBO)"
                        :fi "Yhteisön tosiasialliset edunsaajat"}}

   :kyc-tenant/confirmation-place
   {:data/type    :data.type/text-simple
    :translations {:en "Place"
                   :fi "Paikka"}}

   :kyc-tenant/confirmation-date
   {:data/type         :data.type/date
    :translations      {:en "Date"
                        :fi "Aika"}
    :conditional-field (fn [_answers _kyc-process]
                         false)
    :field/default-authorization {:access/write :role/system}}

   :kyc-tenant/confirmation-name
   {:data/type    :data.type/text-simple
    :translations {:en "Name"
                   :fi "Nimi"}}

   :kyc-tenant/number-of-signers
   {:data/type    :data.type/keyword
    :options      [{:key          :one
                    :translations {:en "1"
                                   :fi "1"}
                    :ord          1.0}
                   {:key          :two
                    :translations {:en "2"
                                   :fi "2"}
                    :ord          2.0}]
    :translations {:en "Number of signers"
                   :fi "Allekirjoittajien lukumäärä"}}

   :kyc-tenant/signer-name-1
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:one :two]))
    :translations      {:en "Signer 1 - Full name"
                        :fi "Allekirjoittaja 1 - Nimi"}}

   :kyc-tenant/signer-email-1
   {:data/type         :data.type/email
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:one :two]))
    :mandatory-field?  (fn [_answers kyc-process]
                         (= :kyc-process.status/wip (:kyc-process/status kyc-process)))
    :validation-fn     (fn [{:keys [answers]}]
                         (when-not (common-email/optional-valid-email? (:kyc-tenant/signer-email-1 answers))
                           :invalid-email))
    :translations      {:en "Signer 1 - Email"
                        :fi "Allekirjoittaja 1 - Sähköpostiosoite"}}

   :kyc-tenant/type-of-identification-attachment-1
   {:data/type         :data.type/keyword
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:one :two]))
    :options           kyc-options/signer-identification-options
    :translations      {:en "Signer 1 - Identification type"
                        :fi "Allekirjoittaja 1 - Tunnistamisasiakirjan tyyppi"}}

   :kyc-tenant/identification-attachment-1
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (and (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])
                              (not= :identification.type/provided-in-previous-questions
                                    (:kyc-tenant/type-of-identification-attachment-1
                                     answers))))
    :mandatory-field?  (fn [answers _kyc-process]
                         (and (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])
                              (not= :identification.type/provided-in-previous-questions
                                    (:kyc-tenant/type-of-identification-attachment-1
                                     answers))))
    :translations
    {:en "Signer 1 - Upload certified copy of a valid identification"
     :fi "Allekirjoittaja 1 - Liitä oikeaksi todistettu kopio voimassaolevasta asiakirjasta"}}


   :kyc-tenant/signer-name-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:two]))
    :translations      {:en "Signer 2 - Full name"
                        :fi "Allekirjoittaja 2 - Nimi"}}

   :kyc-tenant/signer-email-2
   {:data/type         :data.type/email
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:two]))
    :mandatory-field?  (fn [_answers kyc-process]
                         (= :kyc-process.status/wip (:kyc-process/status kyc-process)))
    :validation-fn     (fn [{:keys [answers]}]
                         (when-not (common-email/optional-valid-email? (:kyc-tenant/signer-email-2 answers))
                           :invalid-email))
    :translations      {:en "Signer 2 - Email"
                        :fi "Allekirjoittaja 2 - Sähköpostiosoite"}}

   :kyc-tenant/type-of-identification-attachment-2
   {:data/type         :data.type/keyword
    :conditional-field (fn [answers _kyc-process]
                         (some #{(:kyc-tenant/number-of-signers answers)} [:two]))
    :options           kyc-options/signer-identification-options
    :translations      {:en "Signer 2 - Identification type"
                        :fi "Allekirjoittaja 2 - Tunnistamisasiakirjan tyyppi"}}

   :kyc-tenant/identification-attachment-2
   {:data/type         :data.type/file
    :conditional-field (fn [answers _kyc-process]
                         (and (some #{(:kyc-tenant/number-of-signers answers)} [:two])
                              (not= :identification.type/provided-in-previous-questions
                                    (:kyc-tenant/type-of-identification-attachment-2
                                     answers))))
    :mandatory-field?  (fn [answers _kyc-process]
                         (and (some #{(:kyc-tenant/number-of-signers answers)} [:two])
                              (not= :identification.type/provided-in-previous-questions
                                    (:kyc-tenant/type-of-identification-attachment-2
                                     answers))))
    :translations
    {:en "Signer 2 - Upload certified copy of a valid identification"
     :fi "Allekirjoittaja 2 - Liitä oikeaksi todistettu kopio voimassaolevasta asiakirjasta"}}



   :kyc-tenant/signature-info-1
   {:data/type       :data.type/info
    :optional-field? true
    :translations
    {:en
     (str
      "On behalf of the investor, I hereby confirm that the information I have declared "
      "in this form and in its appendices are true and correct. "
      "I undertake to inform any changes to the declared information within 30 days of the change.")
     :fi
     (str
      "Vakuutan, että tässä lomakkeessa ja sen liitteissä olevat tiedot ovat oikeita, "
      "ja että sijoittaja sitoutuu ilmoittamaan näiden tietojen muutoksista 30 päivän kuluessa muutoksesta.")}}

   :kyc-tenant/signature-info-2
   {:data/type       :data.type/info
    :optional-field? true
    :translations
    {:en (str "By signing the Client Information Form I understand that the collected personal "
              "data may be shared and disclosed within the company to customer service, "
              "other customer relationship management, risk management and marketing purposes. "
              "The company has a right to disclose  personal data to external service providers, "
              "local tax and financial supervisory authorities in tax reporting "
              "and supervisory purposes.")
     :fi (str "Allekirjoittamalla tämän lomakkeen ymmärrän, että kerättyä henkilötietoa "
              "voidaan siirtää ja luovuttaa yrityksen sisällä asiakaspalveluun "
              "ja muuhun asiakassuhteen hoitamiseen, riskienhallintaan ja markkinointiin. "
              "Yrityksellä voi myös olla oikeus luovuttaa tietoja ulkopuolisille "
              "palveluntarjoajille sekä Verohallinnolle että Finanssivalvonnalle "
              "valvonta- ja veroraportointitarkoituksiin.")}}


   :kyc-tenant/signature-place
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])))
    :style             "line"
    :translations      {:en "Place"
                        :fi "Paikka"}}

   :kyc-tenant/signature-date
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])))
    :style             "line"
    :translations      {:en "Date"
                        :fi "Aika"}}

   :kyc-tenant/signature-name
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])))
    :style             "line"
    :translations      {:en "Name"
                        :fi "Nimi"}}

   :kyc-tenant/signature-signature
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:one :two])))
    :style             "line"
    :translations      {:en "Signature"
                        :fi "Allekirjoitus"}}


   :kyc-tenant/signature-place-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:two])))
    :style             "line"
    :translations      {:en "Place"
                        :fi "Paikka"}}

   :kyc-tenant/signature-date-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:two])))
    :style             "line"
    :translations      {:en "Date"
                        :fi "Aika"}}

   :kyc-tenant/signature-name-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:two])))
    :style             "line"
    :translations      {:en "Name"
                        :fi "Nimi"}}

   :kyc-tenant/signature-signature-2
   {:data/type         :data.type/text-simple
    :conditional-field (fn [answers kyc-process]
                         (and (some #{(:kyc-process/status kyc-process)}
                                    [:kyc-process.status/signatures
                                     :kyc-process.status/waiting-for-e-sign])
                              (some #{(:kyc-tenant/number-of-signers answers)} [:two])))
    :style             "line"
    :translations      {:en "Signature"
                        :fi "Allekirjoitus"}}











  })
